module.exports = __webpack_public_path__ + "fonts/Gilroy-RegularItalic.4b9bfe4d.ttf";